import { render, staticRenderFns } from "./Cultural-auction.vue?vue&type=template&id=50194904&scoped=true"
import script from "./Cultural-auction.vue?vue&type=script&lang=js"
export * from "./Cultural-auction.vue?vue&type=script&lang=js"
import style0 from "./Cultural-auction.vue?vue&type=style&index=0&id=50194904&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50194904",
  null
  
)

export default component.exports